// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__YgZSr"};